import { AnySelection, seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export const boundaryLine = (value: number, className: string) =>
    seriesSvgLine()
        .crossValue(deriveTime)
        .mainValue(value)
        .decorate((s: AnySelection) => {
            s.classed(`boundary-line ${className}`, true);
        });

export const boundaryLines = (lowerBoundary: number, upperBoundary: number) => [
    boundaryLine(upperBoundary, 'upper'),
    boundaryLine(lowerBoundary, 'lower'),
    boundaryLine(0, 'zero'),
];
